import React from 'react';
import { string, shape, func } from 'prop-types';
import ClassNames from 'classnames';
import moment from 'moment';
import 'react-dates/initialize';
import { DayPickerRangeController } from 'react-dates';
import BaseComponent from '../.internal/BaseComponent';
import Icon from '../icon/Icon';
import 'react-dates/lib/css/_datepicker.css';
import './DateRangePicker.scss';

export default class DateRangePicker extends BaseComponent {
  constructor(props) {
    super(props);

    this.dateFormat = 'MM-DD-YYYY';

    this.state = {
      startDate: null,
      endDate: null,
      focusedInput: 'startDate'
    };
  }

  setFocusedInput = focusedInput => {
    const { onDatesFocus } = this.props;

    if (typeof onDatesFocus !== 'undefined') {
      onDatesFocus(focusedInput);
    }

    this.setState({ focusedInput: focusedInput || 'startDate' });
  };

  onDatesChangeHandler = ({ startDate, endDate }) => {
    const { onChange } = this.props;
    const startDateString =
      startDate === null ? null : moment(startDate, this.dateFormat);
    const endDateString =
      endDate === null ? null : moment(endDate, this.dateFormat);

    if (typeof onChange === 'function') {
      onChange(startDate, endDate);
    } else {
      const updateObject = {
        ...this.state,
        startDate: startDateString,
        endDate: endDateString
      };

      this.setState(updateObject);
    }
  };

  disableDatesOutsideRange = day => {
    const { minDate, maxDate } = this.props;

    return (
      (minDate && day.isBefore(moment(minDate).endOf('day'))) ||
      (maxDate && day.isAfter(moment(maxDate).endOf('day')))
    );
  };

  render() {
    const {
      startDate,
      endDate,
      style,
      id,
      className,
      initialVisibleMonth
    } = this.props;

    const componentClasses = ClassNames('date-range-picker', className);
    const startDateValue =
      typeof startDate === 'string' ? startDate : this.state.startDate;
    const endDateValue =
      typeof endDate === 'string' ? endDate : this.state.endDate;
    const { focusedInput } = this.state;

    return (
      <div id={id} className={componentClasses} style={style}>
        <DayPickerRangeController
          endDate={moment(endDateValue)}
          focusedInput={focusedInput}
          hideKeyboardShortcutsPanel
          initialVisibleMonth={() => initialVisibleMonth}
          isOutsideRange={this.disableDatesOutsideRange}
          navPrev={
            <div className="date-range-picker__nav-button date-range-picker__nav-button--left">
              <Icon
                className="date-range-picker__nav-icon"
                icon="chevronLeft"
              />
            </div>
          }
          navNext={
            <div className="date-range-picker__nav-button date-range-picker__nav-button--right">
              <Icon
                className="date-range-picker__nav-icon"
                icon="chevronRight"
              />
            </div>
          }
          onDatesChange={this.onDatesChangeHandler}
          onFocusChange={this.setFocusedInput}
          startDate={moment(startDateValue)}
        />
      </div>
    );
  }
}

DateRangePicker.propTypes = {
  startDate: string,
  endDate: string,
  className: string,
  minDate: string,
  maxDate: string,
  style: shape({}),
  initialVisibleMonth: shape({}),
  onChange: func,
  onDateFocus: func,
  onBlur: func
};

DateRangePicker.defaultProps = {
  startDate: undefined,
  endDate: undefined,
  className: undefined,
  minDate: undefined,
  maxDate: undefined,
  style: undefined,
  initialVisibleMonth: moment().startOf('month'),
  onChange: undefined,
  onDateFocus: undefined,
  onBlur: undefined
};
